import Flex from 'antd/lib/flex';
import Modal from 'antd/lib/modal';
import Radio from 'antd/lib/radio';
import Typography from 'antd/lib/typography';
import * as React from 'react';

export interface RolloutDayOption {
    day: number;
    percent: number;
}

interface AdvanceRolloutModalProps {
    open: boolean;
    loading: boolean;
    currentDay: number;
    currentPercent: number;
    dayOptions: RolloutDayOption[];
    onAdvance: (option: RolloutDayOption) => void;
    onClose: () => void;
}

const dayOptionStyle: React.CSSProperties = {
    flex: '0 0 72px',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 6,
    marginInlineEnd: 0,
};

const AdvanceRolloutModal: React.FC<AdvanceRolloutModalProps> = (props) => {
    const [selectedDay, setSelectedDay] = React.useState<number>();
    const selectedOption = props.dayOptions.find((option) => option.day === selectedDay) ?? props.dayOptions[0];

    return (
        <Modal
            title="Advance rollout"
            open={props.open}
            okText="Advance rollout"
            onOk={() => props.onAdvance(selectedOption)}
            onCancel={props.onClose}
            confirmLoading={props.loading}
            afterClose={() => setSelectedDay(undefined)}
            maskClosable
            width={600}
        >
            <Flex vertical gap={16}>
                <Typography.Text type="secondary">
                    Currently on day {props.currentDay} ({props.currentPercent}%). Runway will continue the rollout
                    sequence from the day you pick.
                </Typography.Text>
                <Radio.Group
                    value={selectedOption?.day}
                    onChange={(event) => setSelectedDay(event.target.value)}
                    // "safe" keeps the first options reachable when the row overflows and scrolls.
                    style={{
                        display: 'flex',
                        justifyContent: 'safe center',
                        gap: 8,
                        overflowX: 'auto',
                        paddingBottom: 4,
                    }}
                >
                    {props.dayOptions.map((option) => (
                        <Radio key={option.day} value={option.day} style={dayOptionStyle}>
                            <Flex vertical align="center">
                                <Typography.Text type="secondary">Day {option.day}</Typography.Text>
                                <Typography.Text strong>{option.percent}%</Typography.Text>
                            </Flex>
                        </Radio>
                    ))}
                </Radio.Group>
            </Flex>
        </Modal>
    );
};

export default AdvanceRolloutModal;
